/* lua.js generated code 0.3.0 */

module.exports = table(
    // 基本只出现一次，需加载资源，性价比低，移除
)
